// extracted by css-extract-rspack-plugin
var _1 = "KLBdCKWgKTaH3PlLUqJOAg--";
var _2 = "YzkEAhSfFpyw-8S5BZeOOQ--";
var _3 = "sEYVH5YGVfQhubho8Esfpw--";
var _4 = "C1j-furs5ZPuUs4ap8j9Bw-- sEYVH5YGVfQhubho8Esfpw--";
export { _1 as "native", _2 as "none", _3 as "normal", _4 as "plain" }
